var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90909 15.5455H1.29091C1.13024 15.5455 1 15.4152 1 15.2545V5.48414C1 5.40698 1.03065 5.33299 1.08521 5.27843L5.27843 1.08521C5.33299 1.03065 5.40698 1 5.48413 1H12.2C12.3607 1 12.4909 1.13024 12.4909 1.29091V4.49091",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14525 5.50909H5.07252C5.23319 5.50909 5.36343 5.37885 5.36343 5.21818V1",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 12,
    r: 4,
    stroke: "black",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1634 10.6063V13.3284C10.1634 13.5743 10.4495 13.7093 10.6393 13.553L12.3532 12.1415C12.4978 12.0224 12.4938 11.7996 12.345 11.6858L10.631 10.3752C10.4396 10.2288 10.1634 10.3653 10.1634 10.6063Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaGallery);
export default __webpack_public_path__ + "static/media/media-gallery.206e7ec94443a43d6f03bfd4b6d9685b.svg";
export { ForwardRef as ReactComponent };